// import { CustomTag } from '../Tags/CustomTag';
import { DialogTrigger } from '../Dialog/Dialog';
import './GeneralCard.css';
const ribbonColors = ['var(--blue-300)', 'var(--green-350)', '#f7931e']
const defaultColor = 'var(--blue-300)';

export const GeneralCard = ({ title, children, dialog, ribbon, disabled=false}) => {
  return (<div className="general-card-component">
    {ribbon && <div className='ribbons-container'>
      {/* <span className='ribbon'>{ribbon}</span>
      <span className='ribbon'>{ribbon}</span> */}
      {ribbon.filter?.(r => r.when)?.map?.((r, i, a) => <span className='ribbon' key={r.label} style={{
        backgroundColor: r.color ?? ribbonColors[i % ribbonColors.length] ?? defaultColor,
        left: i < (a.length - 1) ? `${-0.5 * (ribbon.length - 1 - i)}rem` : ''
      }}>{r.label}
      </span>)}
    </div>
    }
    <div className='card-content-container'>
      {(title || dialog) && <div className='card-header'>
        {dialog && <DialogTrigger dialogContent={dialog} disabled={disabled} onCloseCallback={dialog.onCloseCallback}>
          <div className={`more-options-container ${disabled ? 'disabled' : ''}`}>
            <span>
              <i className='icon-more-horizontal'></i>
            </span>
          </div>
        </DialogTrigger>}
        {title ?? ''}
      </div>}
      {children}
    </div>

    {/* <div className='more-info'>
      {dialog && <DialogTrigger dialogContent={dialog}>
        <div className='more-options-container'>
          <span>
            <i className='icon-more-horizontal'></i>
          </span>
        </div>
      </DialogTrigger >}
    </div> */}
  </div>
  )

}